import { StatusFormatter } from '@components'

import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { billStatusToTitleKey } from '@features/bills/constants/billStatusToTitleKey'
import { BillStatus as BillStatusEnum } from '@features/bills/enums/billStatus'

import { billStatusToStatusFormatterVariant } from '../../../../../constants/billStatusToStatusFormatterVariant'

interface BillStatusProps {
  status: BillStatusEnum
  title?: string
}

export const BillStatus = ({ status }: BillStatusProps): ReactElement => {
  const { t } = useTranslation()

  const titleKey = billStatusToTitleKey[status]
  const variant = billStatusToStatusFormatterVariant[status]

  return <StatusFormatter variant={variant} title={t(titleKey)} />
}
